import styled from 'styled-components';

const Place = styled('div')`
  position: relative;
  top: ${(props) => props.$top ?? 'auto'};
  bottom: ${(props) => props.$bottom ?? 'auto'};
  right: ${(props) => props.$right ?? 'auto'};
  left: ${(props) => props.$left ?? 'auto'};
  display: ${(props) => props.$display ?? 'block'};
  height: ${(props) => props.$height ?? 'auto'};
  width: ${(props) => props.$width ?? 'auto'};
  ${(props) => (props.$padding ? `padding: ${props.$padding};` : '')};
  ${(props) => (props.$margin ? `margin: ${props.$margin};` : '')};
  ${(props) => (props.$zIndex ? `z-index: ${props.$zIndex};` : '')};
  ${(props) => (props.$position ? `position: ${props.$position};` : '')};
  ${(props) => (props.$overflow ? `overflow: ${props.$overflow};` : '')};
  ${(props) => (props.$border ? `border: ${props.$border};` : '')};
  ${(props) => (props.$wordbreak ? `word-break: ${props.$wordbreak};` : '')};
  ${(props) => (props.$maxWidth ? `max-width: ${props.$maxWidth};` : '')};
  ${(props) => (props.$maxHeight ? `max-height: ${props.$maxHeight};` : '')};
  ${(props) => (props.$transition ? `transition: ${props.$transition};` : '')};
  ${(props) => (props.$cursor ? `cursor: ${props.$cursor};` : '')};
`;

export default Place;
